import React, { useRef, useState, useMemo } from 'react';
import { useAuth } from '../../hooks/AuthProvider';
import JoditEditor from 'jodit-react';
import { Box, Flex } from 'reflexbox';

export const CreateArticle = ({ placeholder }) => {
    const editor = useRef(null);
	const [content, setContent] = useState('');
    const config = useMemo(() => ({
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: placeholder || 'Start typings...'
        }),
        [placeholder]
    );
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    
    const auth = useAuth();

    return (
        <Box 
            width="100%" 
            paddingTop="40px" 
            paddingLeft="40px" 
            paddingRight="40px"
        >
            <Flex flexDirection="column">
                <h1>Admin Dashboard</h1>
                <Flex flexDirection="row">
                    <button 
                        type="submit" 
                        className="w-60 
                            text-white 
                            bg-primary-600 
                            hover:bg-primary-700 
                            focus:ring-4 
                            focus:outline-none 
                            focus:ring-primary-300 
                            font-medium 
                            rounded-lg 
                            text-sm 
                            px-5 
                            py-2.5 
                            text-center 
                            dark:bg-primary-600 
                            dark:hover:bg-primary-700 
                            dark:focus:ring-primary-800"
                        onClick={() => {
                            window.location.href = "/admin";
                        }}
                    >
                        Back
                    </button>
                    <Box marginLeft="20px">
                        <button 
                            type="submit" 
                            className="w-60 
                                text-white 
                                bg-primary-600 
                                hover:bg-primary-700 
                                focus:ring-4 
                                focus:outline-none 
                                focus:ring-primary-300 
                                font-medium 
                                rounded-lg 
                                text-sm 
                                px-5 
                                py-2.5 
                                text-center 
                                dark:bg-primary-600 
                                dark:hover:bg-primary-700 
                                dark:focus:ring-primary-800"
                                onClick={() => auth.logOut()}
                        >
                            Logout
                        </button>
                    </Box>
                </Flex>
            </Flex>
            <div>
                <Box marginTop="20px" marginBottom="20px">
                    <input 
                        type="text" 
                        placeholder="Title" 
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        className="w-60"
                    />
                </Box>
                <JoditEditor
                    ref={editor}
                    value={content}
                    config={config}
                    tabIndex={1} // tabIndex of textarea
                    onChange={description => {
                        setDescription(description);
                    }}
                />
            </div>
            <Box marginTop="20px">
                <button 
                    type="submit" 
                    className="w-60 
                        text-white 
                        bg-primary-600 
                        hover:bg-primary-700 
                        focus:ring-4 
                        focus:outline-none 
                        focus:ring-primary-300 
                        font-medium 
                        rounded-lg 
                        text-sm 
                        px-5 
                        py-2.5 
                        text-center 
                        dark:bg-primary-600 
                        dark:hover:bg-primary-700 
                        dark:focus:ring-primary-800"
                        onClick={() => {
                            // axios.post(`http://127.0.0.1:8000/article/`,null,  {
                            //     params: {
                            //         title: title,
                            //         description: description,
                            //     }
                            // })
                            // .then(res => {
                            //     window.location.href = "/admin";
                            // })
                            // .catch(error => {
                            //     console.error('Error fetching articles:', error);
                            // });
                        }}
                >
                    Create
                </button>
            </Box>
        </Box>
    )
}